<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
    <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/menuinicial">Inicio Usuario </router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/TrazabilidadPorcinos">Trazabilidad Porcinos</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
  <div>
  <Menu/>
    
  <b-card>
    
   <br>

        
          <span class="card-title">Registro de ganado porcino</span>
          <form id="formRegistro" autocomplete="off" @submit.prevent="registro" enctype="multipart/form-data">
            <input type="text" placeholder="Unidad" :value=unidad required disabled>
            <input type="date" name="fecharegistro" id="fecharegistro" placeholder="Fecha" v-on:click=usuario() required>
            <input type="hidden" name="factura" id="factura" placeholder="Factura" pattern=".{5,20}" >
            <input type="hidden" name="guia" placeholder="Guía" pattern=".{4,10}" >
            <input type="number"  name="orden" placeholder="Orden de Sacrificio" pattern=".{5,10}" required>
            <input type="text" name="iniciales" placeholder="Iniciales" pattern=".{3,10}" required>
            <input type="text" name="fierro" id="fierro" placeholder="Fierro" pattern=".{1,10}" required v-on:click=setserie()>
            <input type="text" name="serie" id="serie" placeholder="Serie" pattern=".{0,5}" readonly>
            <input type="number" v-model="value" name="canal" id="canal" placeholder="Número de canal" pattern=".{3,10}" v-on:click=setserie() required>
            <input type="number" id="arete" name="arete" placeholder="Número de canal" v-on:click=numerocanal() pattern=".{3,20}" required>
              
             <input type="hidden" name="usuarioForma" id="usuarioForma" :value=usuariolocal>
             <input type="hidden" name="idForma" id="idForma" :value=idActual>
             <input type="hidden" name="unidadForma" id="unidadForma" :value=unidad>
             <input type="hidden" name="fotoForma" id="fotoForma" :value=fotoActual>

           
<div class="card-action">

                        <input type="submit" value="Registrar" class="btn btn-outline-success ">
                           
        </div>
            </form>
       
        
          
      
      



    <b-card-body class="text-center">
      <b-card-title>Pantalla de inicio</b-card-title>

      <b-card-text>
       <div>
    <h5>Listado del día {{areteEditar}} <input width="4" type="date" name="fechadia" id="fechadia" placeholder="Fecha" v-on:click=ajaxdelay() >
     <b-button variant="primary" v-on:click=ajax()>ACTUALIZAR</b-button>
<p id="datetime"></p>
    </h5>
   <vue-good-table
   :columns="columns"
     :rows="rows"
     :line-numbers="true"
     @on-cell-click="onCellClick"
     
     :pagination-options="{
       enabled:true,
      
       mode:'remote',
       perPage:500,
       position:'top',
       perPageDropdown:[10,50,100],
       nextLabel:'Siguiente',
       PrevLabel:'Anterior',
       rowsPerPageLabel:'Filas por página',
       ofLabel:'de'
     }"
     :search-options="{
       enabled:true,
       trigger:'enter',
       placeholder:'Buscar'
     }"
   >
     <template slot="table-row" slot-scope="props">

        <span v-if="props.column.field == 'canal'">
      <input type="text" placeholder="Canal" :id="'canaltabla'+props.formattedRow['id']" name="canaltabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'sng'">
      <input type="text" placeholder="Arete" :id="'aretetabla'+props.formattedRow['id']" name="aretetabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'iniciales'">
      <input type="text" placeholder="Iniciales" :id="'inicialestabla'+props.formattedRow['id']" name="inicialestabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'fecha'">
      <input type="text" placeholder="Fecha" :id="'fechatabla'+props.formattedRow['id']" name="fechatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>
    
    <span v-else-if="props.column.field == 'factura'">
      <input type="text" placeholder="Factura" :id="'facturatabla'+props.formattedRow['id']" name="facturatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>

    <span v-else-if="props.column.field == 'guia'">
      <input type="text" placeholder="Factura" :id="'guiatabla'+props.formattedRow['id']" name="guiatabla"  :value="props.formattedRow[props.column.field]" :disabled=true> 
    </span>

    <span v-else-if="props.column.field == 'permiso'">
      <input type="text" placeholder="Permiso" :id="'permisotabla'+props.formattedRow['id']" name="permisotabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'fierro'">
      <input type="text" placeholder="Fierro" :id="'fierrotabla'+props.formattedRow['id']" name="fierrotabla"  :value="props.formattedRow[props.column.field]" :disabled=campostabla> 
    </span>

    <span v-else-if="props.column.field == 'eliminar'">
       <b-button variant="outline-danger">Eliminar</b-button>
    </span>
    <span v-else-if="props.column.field == 'editar'">
       <b-button variant='danger'>Editar</b-button>
       
    </span>
    <span v-else-if="props.column.field == 'editararete'">
       <input type="number" id="areteeditado" name="areteeditado" placeholder="Número de canal" :value="props.formattedRow['sng']" :disabled="false">  
    </span>
    <span v-else>
       {{props.formattedRow[props.column.field]}}  
    </span>
    
  </template>
   </vue-good-table>
</div>
      </b-card-text>

      <b-button variant="primary">Go somewhere</b-button>
    </b-card-body>
  </b-card>
</div>

    
  </div>
</template>

<script>
//{{props.formattedRow[props.column.field]}}
import Cabecera from './Cabecera' //v-on:keyup.enter="onEnter"
import Menu from './Menu'
import axios from 'axios'
import swal from 'sweetalert'
import sesion from '../mixins/sesion'
import eliminarporcinos from '../mixins/eliminarporcinos'
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'
export default {
  name: 'TrazabilidadPorcinos',
  data () {
    return {
        value:'1',
        campostabla:false,
      msg: 'Número de arete',
      usuariolocal:'',
      fotolocal:'',
      unidad:'',
        fecha1:'',
        fecha2:'',
        areteEditar:'',
      columns:[
        {
          label:'Id',
          field:'id',
          hidden:true
        },
        {
          label:'Folio',
          field:'canal'
        },
        {
          label:'Arete',
          field:'sng'
        },
        {
          label:'Ini.',
          field:'iniciales'
        },
        {
          label:'Fecha',
          field:'fecha',
          type:'date',
          dateInputFormat:'yyyy-mm-dd',
          dateOutputFormat:'yyyy-mm-dd'
        },
        {
          label:'Factura',
          field:'factura'
        },
        {
          label:'Guía',
          field:'guia'
        },
        {
          label:'Permiso',
          field:'permiso'
        },
        {
          label:'Fierro',
          field:'fierro'
        },
        {
          label:'Editar',
          field:'editar'
        },
        {
          label:'Eliminar',
          field:'eliminar'
        },
      ],
      rows:[

      ]
    }
  },
  computed:{
      ...mapState(['usuarioActual','idActual','fotoActual'])
  },
  methods:{
    setserie(){
    var d=new Date()
                        this.d=document.getElementById("fecharegistro").value
    document.getElementById('serie').value=this.d.split('-')[0]
  },
    numerocanal(){
      var d=new Date()
          this.d=document.getElementById("fecharegistro").value

          document.getElementById("arete").value=document.getElementById("canal").value+this.d.split('-')[2]+this.d.split('-')[1]+document.getElementById("fierro").value


          document.getElementById("arete").focus()
    },
    nextPlease(){
      document.getElementById('factura').focus()
    },
     onCellClick(params) {
         if(params.column.field=="eliminar"){
       if(this.eliminarporcinos(params.row.id)){
            //swal('hola')
           
       } 
       else{
         setTimeout(() => {  this.ajax(); }, 3000)
       }        
        // setTimeout(() => {  this.ajax(); }, 5000);
        //this.ajax()
         
         }
         if(params.column.field=="editar"){
           const idquery=params.row.id
           
           //const aretequery=params.row.arete
           //swal('params.row.arete'+idquery)
           //const aretequery=props.formattedRow['sng']
           const aretequery=document.getElementById('aretetabla'+idquery).value
           const canalquery=document.getElementById('canaltabla'+idquery).value
           const inicialesquery=document.getElementById('inicialestabla'+idquery).value
           const facturaquery=document.getElementById('facturatabla'+idquery).value
           const guiaquery=document.getElementById('guiatabla'+idquery).value
           const permisoquery=document.getElementById('permisotabla'+idquery).value
           const fierroquery=document.getElementById('fierrotabla'+idquery).value
          axios.get('https://micomidasegura.mx/comidaSegura/api/crud/editarPorcinos.php?id='+idquery+'&sng='+aretequery
          +'&canal='+canalquery+'&iniciales='+inicialesquery+'&factura='+facturaquery+'&guia='+guiaquery+'&permiso='+permisoquery+'&fierro='+fierroquery)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            swal('Registro editado'+res.data)
                        } else {
                          swal('Error al editar registro' + res.data)
                        }
                    })}
         
         
        this.ajax()
         //
   // alert (params.row.id) // params.row - row object   /// 
    // params.pageIndex - index of this row on the current page.
    // params.selected - if selection is enabled this argument 
    // indicates selected or not
    // params.event - click event
  },
      /*onEnter: function() {
      swal("Mensaje de enter")
    },*/
    fecha(){
        var dt = new Date();
    document.getElementById("datetime").innerHTML = ((dt.getFullYear() +"-"+ (("0"+(dt.getMonth()+1)).slice(-2)) 
    +"-"+ ("0"+dt.getDate()).slice(-2)));
    },
    ajax(){
      //this.getId()
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     const fecha = document.getElementById("fechadia").value
     const unidadquery=this.unidad
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPorcinosProceso.php?fecha='+fecha+'&unidad='+unidadquery)
      .then(response=>{
        this.rows=response.data
      })

    },
    ajaxdelay(){
      setTimeout(() => {  this.ajax(); }, 2500)
    },
    getId(){
           this.usuario()

            const id = document.getElementById("usuarioForma").value
            
            axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getPerfilUsuario.php?id='+ id)
            
                .then(response=>{
                   
                    this.unidad = response.data.unidad
                  
                    
                })
                   
        }, 
    usuario(){
        
     //const fecha = JSON.parse(document.getElementsByName('fecharegistro').value)
     var yourString = this.$localStorage.get('token');
     var result = yourString.slice(1,-1);
     this.usuariolocal= result
     const tok=this.usuariolocal
      axios.get('https://micomidasegura.mx/comidaSegura/api/crud/getUserData2.php?token='+tok)
      .then(response=>{
       
        this.usuariolocal=response.data.email
        this.unidad=response.data.unidad
        this.perfil=response.data.perfil
      })

    },
    ticketIncremento(){
       // document.getElementById('canal').value=document.getElementById('canal').value++
    this.value=Number(this.value)+1
    },
    registro(){
            
                //document.getElementById('usuarioForma').value=this.$store.state.usuario.token
                /*document.getElementById("usuarioForma").value =this.$store.state.usuarioActual
                document.getElementById("fotoForma").value =this.$store.state.fotoActual
                document.getElementById("idForma").value =this.$store.state.idActual*/
               //this.usuario()
               const form=document.getElementById('formRegistro')
                axios.post('https://micomidasegura.mx/comidaSegura/api/crud/porcinos1.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    this.ajax()
                    this.ticketIncremento()
                        document.getElementById("arete").value=""
                        var d=new Date()
                        this.d=document.getElementById("fecharegistro").value

                        document.getElementById("arete").value=document.getElementById("canal").value+this.d.split('-')[2]+this.d.split('-')[1]+document.getElementById("fierro").value
                        document.getElementById("arete").focus()
                  /* swal({
                   title:'Registro almacenado'+res.data,
                    //title:'Registro almacenado'+this.$localStorage.get('usuario')+this.$localStorage.getElementById('token'),
                    icon: 'success'})*/
                     
                    //this.direccionamiento()
                })
            
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar',
                    icon: 'error'})  
            }
        },
  },
  created(){
    this.ajax()
    this.usuario()
  },
  components:{
    Cabecera,
    Menu
  },
  mixins:[sesion,eliminarporcinos]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/TrazabilidadPorcinos.vue